// Cloudflare Turnstile public site key (safe to expose in the client bundle).
// Override per environment via REACT_APP_TURNSTILE_SITE_KEY if needed.
export const TURNSTILE_SITE_KEY =
  process.env.REACT_APP_TURNSTILE_SITE_KEY || '0x4AAAAAADyQ7RPo5-xrlHd9';

export default TURNSTILE_SITE_KEY;
